/* Native navigation disclosure: menus remain server rendered and unbounded. */
if (!customElements.get('zentus-explorer')) {
  customElements.define('zentus-explorer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.panel = this.querySelector('[data-zxe-panel]');
      this.toggles = [...this.querySelectorAll('[data-zxe-toggle]')];
      this.addEventListener('click', event => {
        const toggle = event.target.closest('[data-zxe-toggle]');
        if (toggle) { this.opener = toggle; this.setOpen(this.panel.hidden); }
        if (event.target.closest('[data-zxe-close]')) this.setOpen(false, true);
        const group = event.target.closest('[data-zxe-group]');
        if (group) this.selectGroup(group.dataset.zxeGroup);
        const next = event.target.closest('[data-zxe-go]');
        if (next) this.selectPage(next.dataset.zxeGo);
        const accordion = event.target.closest('[data-zxe-accordion]');
        if (accordion) {
          const opening = accordion.getAttribute('aria-expanded') !== 'true';
          this.querySelectorAll('[data-zxe-accordion]').forEach(a => a.setAttribute('aria-expanded', 'false'));
          accordion.setAttribute('aria-expanded', String(opening));
        }
        if (event.target.closest('a, .z-header-actions') && !this.panel.hidden) this.setOpen(false);
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.panel.hidden) { event.preventDefault(); this.setOpen(false, true); }
      }, options);
      document.addEventListener('click', event => {
        if (!this.contains(event.target) && !this.panel.hidden) this.setOpen(false);
      }, options);
      document.addEventListener('focusin', event => {
        if (!this.contains(event.target) && !this.panel.hidden) this.setOpen(false);
      }, options);
      this.resizeObserver = new ResizeObserver(() => this.measure());
      this.resizeObserver.observe(this);
      window.addEventListener('resize', () => this.measure(), options);
    }
    measure() { this.style.setProperty('--zxe-top', `${Math.max(0, this.getBoundingClientRect().bottom)}px`); }
    setOpen(open, restore = false) {
      this.panel.hidden = !open;
      this.querySelector('.zxe-backdrop').hidden = !open;
      this.toggles.forEach(t => t.setAttribute('aria-expanded', String(open)));
      this.querySelector('[data-zxe-burger]').hidden = open;
      this.querySelector('[data-zxe-cross]').hidden = !open;
      if (open) {
        this.measure();
        this.selectPage('root', false);
        this.panel.scrollTop = 0;
        if (matchMedia('(max-width:599px)').matches) this.querySelector('[data-zxe-page="root"] h2').focus();
        else this.querySelector('[data-zxe-group][aria-pressed="true"]')?.focus();
      } else if (restore) this.opener?.focus();
    }
    selectGroup(id) {
      this.querySelectorAll('[data-zxe-group]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.zxeGroup === id)));
      this.querySelectorAll('[data-zxe-group-panel]').forEach(p => p.hidden = p.dataset.zxeGroupPanel !== id);
    }
    selectPage(id, focus = true) {
      this.querySelectorAll('[data-zxe-page]').forEach(p => {
        p.hidden = p.dataset.zxePage !== id;
        if (!p.hidden && focus) p.querySelector('h2')?.focus();
      });
      this.panel.scrollTop = 0;
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; this.resizeObserver?.disconnect(); }
  });
}
